import gql from 'graphql-tag'

export const fetchFreeBeerProductQuery = gql(`
  query ($cartId: String!) {
    getFreeBeerProducts(
        cartId: $cartId
    ) {
        id
        req_id
        name
        sku
        product_desc
        qty
        add_automatic
        valid_to
        campaing
        product_id
        item_id
        image
    }
  }
  `)
